// src/components/lekhi/MCQs.js
import React, { useState } from 'react';
import './MCQs.css';

const MCQs = ({ mcqs, recordItemResult, dotState, totalDots, language, onComplete, onBack }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [answered, setAnswered] = useState(false);

  const labels = language === 'mr'
    ? {
        back: '← मागे',
        title: 'MCQs',
        next: 'पुढे',
        correct: 'अगदी बरोबर!',
        wrong: 'हरकत नाही',
        correctAnswer: 'योग्य उत्तर'
      }
    : {
        back: '← Back',
        title: 'MCQs',
        next: 'Continue',
        correct: 'Correct!',
        wrong: 'No worries',
        correctAnswer: 'Correct answer'
      };

  if (!mcqs || mcqs.length === 0) {
    return (
      <div className="lk-mcq-container">
        <div className="lk-mcq-header">
          <button className="back-btn" onClick={onBack}>{labels.back}</button>
          <div className="lk-mcq-title">{labels.title}</div>
          <div style={{ width: 60 }} />
        </div>
        <div style={{ padding: 40, textAlign: 'center', color: '#6c757d' }}>
          No questions
        </div>
      </div>
    );
  }

  const question = mcqs[currentIndex];
  const isLastQuestion = currentIndex === mcqs.length - 1;

  const handleAnswerTap = (optionKey) => {
    if (answered) return;
    setSelectedAnswer(optionKey);
    setAnswered(true);
    const isCorrect = optionKey === question.correctAnswer;
    if (recordItemResult) {
      recordItemResult(question.id, isCorrect);
    }
    if (navigator.vibrate) {
      if (isCorrect) {
        navigator.vibrate(80);
      } else {
        navigator.vibrate([60, 50, 60, 50, 60]);
      }
    }
  };

  const handleNext = () => {
    if (isLastQuestion) {
      onComplete();
    } else {
      setCurrentIndex(currentIndex + 1);
      setSelectedAnswer(null);
      setAnswered(false);
    }
  };

  const getOptionClass = (optionKey) => {
    if (!answered) return 'lk-mcq-option';
    if (optionKey === question.correctAnswer) return 'lk-mcq-option correct';
    if (optionKey === selectedAnswer && optionKey !== question.correctAnswer) return 'lk-mcq-option wrong';
    return 'lk-mcq-option dimmed';
  };

  const isCorrect = selectedAnswer === question.correctAnswer;

  return (
    <div className="lk-mcq-container">
      <div className="lk-mcq-header">
        <button className="back-btn" onClick={onBack}>{labels.back}</button>
        <div className="lk-mcq-title">{labels.title}</div>
        <div style={{ width: 60 }} />
      </div>

      <div className="lk-mcq-progress">
        <span className="lk-mcq-progress-text">{currentIndex + 1} / {mcqs.length}</span>
        {totalDots > 0 && (
          <div className="lk-mcq-dots">
            {Array.from({ length: totalDots }).map((_, i) => {
              const result = dotState && dotState[i];
              const cls = result === true ? 'correct' : result === false ? 'wrong' : '';
              return <span key={i} className={`lk-mcq-dot ${cls}`} />;
            })}
          </div>
        )}
      </div>

      <div className="lk-mcq-body">
        <div className="lk-mcq-question">{question.question}</div>

        <div className="lk-mcq-options">
          {['A', 'B', 'C', 'D'].map((key) => {
            if (!question.options[key]) return null;
            return (
              <button
                key={key}
                className={getOptionClass(key)}
                onClick={() => handleAnswerTap(key)}
                disabled={answered}
              >
                <span className="lk-mcq-option-key">{key}</span>
                <span className="lk-mcq-option-text">{question.options[key]}</span>
              </button>
            );
          })}
        </div>

        {answered && (
          <div className={`lk-mcq-feedback ${isCorrect ? 'correct' : 'wrong'}`}>
            <div className="lk-mcq-feedback-title">
              {isCorrect ? labels.correct : labels.wrong}
            </div>
            {!isCorrect && (
              <div className="lk-mcq-feedback-correct">
                {labels.correctAnswer}: <strong>{question.correctAnswer}</strong>
              </div>
            )}
            {question.explanation && (
              <div className="lk-mcq-feedback-explanation">{question.explanation}</div>
            )}
          </div>
        )}
      </div>

      {answered && (
        <div className="lk-mcq-footer">
          <button className="lk-mcq-next-btn" onClick={handleNext}>{labels.next}</button>
        </div>
      )}
    </div>
  );
};

export default MCQs;